module.exports = __webpack_public_path__ + "img/profileview.0de89425.svg";